export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: "热血战斗",
    slug: "action",
    description: "燃到爆炸的战斗场面，热血沸腾的冒险旅程",
    icon: "ri-sword-line",
    count: 5,
  },
  {
    name: "搞笑日常",
    slug: "comedy",
    description: "笑料不断，轻松有趣的日常故事",
    icon: "ri-emotion-laugh-line",
    count: 3,
  },
  {
    name: "奇幻冒险",
    slug: "fantasy",
    description: "进入异世界，展开不可思议的冒险之旅",
    icon: "ri-compass-3-line",
    count: 2,
  },
  {
    name: "悬疑推理",
    slug: "mystery",
    description: "烧脑推理，环环相扣的悬疑剧情",
    icon: "ri-search-eye-line",
    count: 3,
  },
  {
    name: "恋爱治愈",
    slug: "romance",
    description: "甜到心底的恋爱故事，温暖治愈的感动",
    icon: "ri-heart-line",
    count: 2,
  },
  {
    name: "日常治愈",
    slug: "slice-of-life",
    description: "慢节奏的美好日常，治愈心灵的温柔时光",
    icon: "ri-sun-line",
    count: 1,
  },
];